import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const CreateInvoiceTaskAttemptSchema = z.object({
  type: z.literal(TaskType.CREATE_INVOICE),
  projectId: z.number(),
});

export type CreateInvoiceTaskAttempt = z.infer<typeof CreateInvoiceTaskAttemptSchema>;
